import Vec3 from 'gl-vec3';
import getPlaneNormal from 'get-plane-normal';
import intersect from 'ray-triangle-intersection';
import { makeGroup, makeHull } from 'mint-turn';

const makeTerrain = (triangles) => {
  const floors = triangles.filter(triangle => getPlaneNormal([], ...triangle)[1] > 0);
  const walls = triangles.filter(triangle => getPlaneNormal([], ...triangle)[1] === 0);
  
  const group = triangles.map((triangle) => {
    const normal = getPlaneNormal([], ...triangle);
    const poly = makeHull(triangle, 0);
    if (normal[1] > 0) {
      poly[0].setAttribute('class', 'terrain floor');
    } else if (normal[1] < 0) {
      poly[0].setAttribute('class', 'terrain ceiling');
    } else {
      poly[0].setAttribute('class', 'terrain wall');
    }
    return poly;
  });
  
  const getFloorIntersection = (origin, backtrack) => {
    const direction = [0, -1, 0];
    const hit = [];
    let result = { distance: Infinity };
    for (let triangle of floors) {
      if (intersect(hit, origin, direction, triangle)) {
        const distance = origin[1] - hit[1];
        if (distance > -backtrack && distance < result.distance) {
          const normal = getPlaneNormal([], ...triangle);
          result = { triangle, hit: Vec3.clone(hit), normal, distance };
        }
      }
    }
    return result;
  };
  
  const getWallIntersection = (origin, backtrack) => {
    const hit = [];
    let result = { distance: Infinity };
    const temp = Vec3.create();
    for (let triangle of walls) {
      const normal = getPlaneNormal([], ...triangle);
      const fakeOrigin = Vec3.scaleAndAdd([], origin, normal, backtrack);
      if (intersect(hit, fakeOrigin, Vec3.negate([], normal), triangle)) {
        const offset = Vec3.subtract(temp, fakeOrigin, hit);
        const distance = Vec3.dot(offset, normal) - backtrack;
        if (distance > -backtrack && distance < result.distance) {
          result = { triangle, hit: Vec3.clone(hit), normal, distance };
        }
      }
    }
    return result;
  };
  
  return [group, getFloorIntersection, getWallIntersection];
};

export default makeTerrain;